<template>
  <div class="complaint-item">
    <div class="order-number" v-if="orderNo">订单编号：{{orderNo}}</div>
    <div class="header">
      <Avatar :src.sync="head_img" icon="ios-person" size="50" />
      <div class="info">
        <div class="left">
          <div class="name">{{nickname}}</div>
          <div class="comment">
            <span>{{item.type_name}}</span>
          </div>
        </div>
        <div class="right">
          <Tag class="tag" color="error">{{item.leixing_name}}</Tag>
          <Tag class="tag" :color="complaintStatusColor">{{complaintStatusText}}</Tag>
          <div class="time">{{item.created_at}}</div>
        </div>
      </div>
    </div>
    <div class="comment-content">{{item.complain}}</div>
    <div class="img-list">
      <el-image style="width: 80px; height: 80px" class="margin-right-10" :src="itm" :preview-src-list="item.img" :fit="'cover'" alt
        v-for="(itm,indx) in item.img" :key="indx">
      </el-image>
    </div>
    <div class="comment-replay" v-if="item.reason">
      <div>平台回复：</div>
      <div class="">{{item.reason}}</div>
    </div>
    <!-- <div class="order" @click="$router.push({name:'order_detail',params:{id:item.order_id}})">
      <div class="left">
        <div class="project">{{item.title}}</div>
        <div class="address">地址：{{item.address}}</div>
      </div>
      <Icon class="icon" type="ios-arrow-forward" color="#666"/>
    </div> -->
    <div class="order" v-if="orderNo || item.title || item.address" @click="$router.push({name:'order_detail',params:{id:item.order_id}})">
      <div class="left">
        <div class="project" v-if="item.title">{{item.title}}</div>
        <div class="address" v-if="item.address">地址：{{item.address}}</div>
      </div>
      <Icon class="icon" type="ios-arrow-forward" color="#666"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'evaluate-item',
  props: {
    item: {
      type: [Array, Object],
      default: {}
    }

  },
  data () {
    return {
      nickname: '',
      head_img: ''
    }
  },
  created () {
    let vm = this
    this.$request('6173cb9f48207', {}).then(res => {
      vm.head_img = res.data.data.user.head_img
      vm.nickname = res.data.data.user.nickname
    })
  },
  computed: {
    complaintStatusText () {
      return this.item && this.item.status == 0 ? '未处理' : '已处理'
    },
    complaintStatusColor () {
      return this.item && this.item.status == 0 ? 'warning' : 'success'
    },
    orderNo () {
      const item = this.item || {}
      const order = item.order || item.order_data || item.base || {}
      return item.number || item.order_no || item.order_number || item.order_sn || order.number || order.order_no || order.order_number || ''
    }
  }

}
</script>

<style scoped lang="less">
.comment-replay {
    margin-top: 10px;
    display: flex;
    align-items: center;
    background-color: #f7f8fa;
    padding: 10px 10px;
  }
  .complaint-item {
    padding-bottom: 10px;
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 20px;

    .order-number {
      color: #333333;
      font-weight: 600;
      margin-bottom: 10px;
    }

    .order {
      padding: 10px;
      background-color: #f7f8fa;
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;

      .project {
        color: #333333;
      }

      .address {
        color: #555555;
      }
    }

    .header {
      display: flex;

      .info {
        display: flex;
        flex: 1;
        height: 50px;
        padding-left: 10px;
        justify-content: space-between;

        .left {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .name {
            font-weight: 600;
          }

          .comment {
            display: flex;
            align-items: center;
            color: #666666;

            span {
              margin-right: 3px;
            }
          }
        }

        .right {
          text-align: right;

          .time {
            text-align: right;
            margin-right: 10px;
          }

          .tag {
            margin-right: 10px;
          }

          .comment {
            display: flex;
            align-items: center;
            color: #666666;

            span {
              margin-right: 3px;
            }
          }
        }
      }
    }

    .comment-content {
      margin-top: 10px;
      color: #333333;
    }

    .img-list {
      display: flex;
      margin-top: 10px;

      .img {
        width: 80px;
        height: 80px;
        object-fit: cover;
        border-radius: 3px;
        margin-right: 10px;
      }
    }
  }
</style>
